import { useReducedMotion } from 'motion/react';
import {
  fadeUpVariant,
  fadeInVariant,
  cardVariant,
  slideInLeft,
  slideInRight,
  staggerContainer,
  quickStagger,
  reducedFadeVariant,
  reducedStagger,
  wordRevealContainer,
  wordRevealChild,
  cinematicEntry,
  dramaticStagger,
  timelineCardVariant,
  featuredCardVariant,
} from '../utils/animations';

export const useAnimationVariants = () => {
  const shouldReduce = useReducedMotion();

  return {
    fadeUp:         shouldReduce ? reducedFadeVariant : fadeUpVariant,
    fadeIn:         shouldReduce ? reducedFadeVariant : fadeInVariant,
    card:           shouldReduce ? reducedFadeVariant : cardVariant,
    slideLeft:      shouldReduce ? reducedFadeVariant : slideInLeft,
    slideRight:     shouldReduce ? reducedFadeVariant : slideInRight,
    stagger:        shouldReduce ? reducedStagger      : staggerContainer,
    quickStagger:   shouldReduce ? reducedStagger      : quickStagger,
    wordReveal:     shouldReduce ? reducedStagger      : wordRevealContainer,
    wordRevealChild: shouldReduce ? reducedFadeVariant : wordRevealChild,
    cinematic:      shouldReduce ? reducedFadeVariant  : cinematicEntry,
    dramaticStagger: shouldReduce ? reducedStagger     : dramaticStagger,
    timelineCard:   shouldReduce ? reducedFadeVariant  : timelineCardVariant,
    featuredCard:   shouldReduce ? reducedFadeVariant  : featuredCardVariant,
  };
};
